module.exports = __webpack_public_path__ + "img/ercode.79e3ca7d.jpg";